import $ from 'jquery';
import inherit from '../core/inherit';
import EventEmitter from '../core/event-emitter';
import * as events from "./events";

/**
 * 리스트 UI에 대한 기본 인터페이스를 제공한다.
 * 통검의 경우 SF.expand와 결합하여 사용하며
 * 탭의 경우 단일 리스트로서 활용한다.
 *
 * @param {jQuery|string} container - 리스트를 감싸는 컨테이너 엘리먼트 또는 해당 엘리먼트를 가리키는 셀렉터
 * @param {string} [itemSelector="li"] - onItemClick 이벤트의 셀렉터. children과 다를 수 있다. 기본값은 li
 * @param {string} [activeClassName="on"] - children 이 활성화 상태일때 부여할 클래스명 기본값은 on
 * @param {number} [cols=1] - 한 줄에 표시되는 아이템의 갯수
 * @constructor
 * @augments EventEmitter
 */
function ClipList({ container, itemSelector, activeClassName, cols = 1 }) {
  EventEmitter.call(this);

  this.$container         = $(container);
  this.itemSelector       = itemSelector || 'li';
  this.activeClassName    = activeClassName || 'on';
  this.indexOfHighlighted = -1;
  this.length             = this.getItems$().length;
  this.cols               = cols;
  this._bindExtendedEvent();
}

inherit(ClipList, EventEmitter, {
  /**
   * 리스트 아이템을 클릭했을 때
   * @emits PlayList#itemClick
   * @private
   */
  _onItemSelect() {
    const self = this;
    this.$container.on('click', this.itemSelector, function (e) {
      self.emit(events.ITEM_CLICK, e, this);
    });
  },
  _bindExtendedEvent() {
    this._onItemSelect();
  },

  /**
   * 지정된 index에 해당하는 리스트 아이템에 activeClassName을 부여한다. 해제하려면 -1을 넣어주면 된다.
   * @param {string|number} idx - 하이라이팅 클래스를 적용할 대상 인덱스 (-1: 해제)
   * @returns {ClipList}
   */
  highlight(idx) {
    const activeClassName = this.activeClassName;
    const $children       = this.getItems$();
    $children.removeClass(activeClassName);
    idx > -1 && $children.eq(idx).addClass(activeClassName);
    this.indexOfHighlighted = idx;
    return this;
  },

  /**
   * jQuery 리스트 아이템을 리턴한다. itemSelector로 지정된것과 관련없이 컨테이너의 모든 자식 요소를 리턴하니 주의
   * @returns {jQuery}
   */
  getItems$() {
    return this.$container.children();
  },

  /**
   * 지정된 리스트 위치에 HTML 요소를 삽입한다.
   * @param {string|number} idx - 요소를 삽입할 리스트의 index
   * @param {jQuery|HTMLElement|string} htmlContents - 삽입할 HTML
   * @returns {ClipList}
   */
  insertTo(idx, htmlContents) {
    $(htmlContents).insertAfter(this.getItems$().eq(idx));
    return this;
  },

  /**
   * @param args
   * @override
   * @returns {ClipList}
   */
  on(...args) {
    EventEmitter.prototype.on.apply(this, args);
    return this;
  },

  /**
   *
   * 인덱스를 한 열에 있는 행의 최대 수로 환산해준다.
   * 예를들어 한 행에 보이는 아이템의 갯수가 n이고
   * n = 3이라면
   * 0~2까지의 index는 2라는 index로 매핑되어야 한다.
   * 3 ~ 5 는 5
   * 6 ~ 8 은 8
   *
   * 그리드 뷰 아이템에 플레이어를 삽입하기 위해 사용한다.
   * @param idx
   * @returns {number}
   */
  indexToPlayerPos(idx) {
    const cols       = this.cols;
    const oneIndexed = idx + 1;
    return Math.ceil(oneIndexed / cols) * cols - 1;
  }
});

export default ClipList;


/** WEBPACK FOOTER **
 ** ./src/VO2/libs/clip-list/clip-list.js
 **/